import { type CSSObject } from '@emotion/react';
import { useTheme, type ThemeNames } from '../../../../../theme';

export type UseDropdownCellOptionStylesReturn = Record<
  | 'childOption'
  | 'button'
  | 'iconWrapper'
  | 'radio'
  | 'checkbox'
  | 'label'
  | 'sublabel'
  | 'base'
  | 'selected'
  | 'disabled'
  | 'destructive',
  CSSObject
>;

export const useDropdownCellOptionStyles = ({
  themeName,
}: {
  themeName?: ThemeNames;
}): UseDropdownCellOptionStylesReturn => {
  const theme = useTheme(themeName);

  return {
    button: {
      display: 'flex',
      minHeight: 40,
      width: '100%',
      padding: theme.spacing('10px', 3),
      alignItems: 'center',
      gap: theme.spacing(2),
      flexShrink: 0,
      flexGrow: 1,
      fontFamily: theme.typography.fontFamily,

      border: 'none',
      borderRadius: 0,
      boxShadow: 'none',
      textAlign: 'left',
    },
    iconWrapper: {
      display: 'inline-flex',
      flexShrink: 0,
      color: theme.icon.primary,
    },
    radio: {
      padding: 0,
    },
    checkbox: {
      padding: 0,
    },
    label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      paddingRight: theme.spacing(2),
      alignItems: 'center',
      gap: theme.spacing(2),
      flex: '1 0 0',
    },
    sublabel: {
      color: theme.text.generic.tertiary,
    },
    childOption: {
      paddingLeft: theme.spacing(8),
    },
    base: {
      fontWeight: theme.typography.fontWeightRegular,
      backgroundColor: 'transparent',
      cursor: 'pointer',
      color: theme.text.generic.primary,
      '&:hover': {
        backgroundColor: theme.menu.background.hover,
      },
      '&:focus-visible': {
        outline: 'none',
        backgroundColor: theme.menu.background.hover,
      },
    },
    selected: {
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.menu.background.selected,
      backdropFilter: theme.backdropFilter.large,
      '&:hover': {
        backgroundColor: theme.menu.background.selected,
        backdropFilter: theme.backdropFilter.large,
      },
      '&:focus-visible': {
        outline: 'none',
        backgroundColor: theme.menu.background.hover,
      },
    },
    disabled: {
      backgroundColor: theme.radioButton.background,
      color: theme.text.interactive.disabled,
      cursor: 'not-allowed',
      '&:hover': {
        backgroundColor: theme.radioButton.background,
      },
    },
    destructive: {
      '&:hover': {
        backgroundColor: theme.menu.background.destructiveHover,
      },
      '&:focus-visible': {
        outline: 'none',
        backgroundColor: theme.menu.background.destructiveHover,
      },
    },
  };
};
